
import { FaLinkedin } from 'react-icons/fa';

import React from 'react';

const About = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      padding: '4rem 2rem',
      fontFamily: 'Arial, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    title: {
      fontSize: '3.5rem',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '3rem',
      letterSpacing: '0.05em'
    },
    content: {
      maxWidth: '800px',
      textAlign: 'center'
    },
    paragraph: {
      fontSize: '1.25rem',
      lineHeight: '1.8',
      marginBottom: '1.5rem',
      fontWeight: '300'
    },
    button: {
      marginTop: '2rem',
      padding: '1rem 2rem',
      fontSize: '1.125rem',
      fontWeight: '600',
      color: '#ffffff',
      backgroundColor: 'transparent',
      border: '2px solid #ffffff',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      textDecoration: 'none'
    },
    buttonHover: {
      backgroundColor: '#ffffff',
      color: '#2a2e35'
    }
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div style={styles.container} id="about">
      <h1 style={styles.title}>ABOUT</h1>
      
      <div style={styles.content}>
        <p style={styles.paragraph}>
          Hi, I'm Michael. I'm a software engineer at Northrop Grumman on an internal tools team. I'm a highly motivated developer, constantly seeking new, challenging, and exciting opportunities to improve my abilities.
        </p>
        
        <p style={styles.paragraph}>
          From working on an online fitness platform to starting a business with a friend, I've had the chance to build some exciting projects.
          If you'd like to join me for the next challenge or are just interested in the site, please feel free to look around or find me on social media.
        </p>

        <p style={styles.paragraph}>
          Thanks for visiting!
        </p>
        
        <a 
          href="https://www.linkedin.com/in/michael-m-60158117a/" 
          target="_blank"
          rel="noopener noreferrer"
          style={{
            ...styles.button,
            ...(isHovered ? styles.buttonHover : {})
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <FaLinkedin />
          My Linkedin
        </a>
      </div>
    </div>
  );
};

export default About;